import { FProgressBar } from '../../../../../components/base';
import { FamilyFields, useFormReadOnly } from '../../../../common';
import {
  useFetchTreatmentPlanV3FamilyPage,
  useTreatmentPlanV3ClientSiblings,
  useTreatmentPlanV3FamilyAdditionalInfo,
  useTreatmentPlanV3FamilyCulturalConsideration,
  useTreatmentPlanV3FamilyMembers,
  useTreatmentPlanV3FamilyPageState,
} from './hooks';
import { TreatmentPlanV3PageContent, TreatmentPlanV3PageLoadState } from '../components';

export default function FamilyForm() {
  const { retry } = useFetchTreatmentPlanV3FamilyPage();
  const { isLoading, hasLoaded, hasLoadError } = useTreatmentPlanV3FamilyPageState();
  const {
    familyMembers,
    isSaving: isSavingMember,
    create: createMember,
    update: updateMember,
    remove: removeMember,
  } = useTreatmentPlanV3FamilyMembers();
  const {
    siblings,
    isSaving: isSavingSibling,
    create: createSibling,
    update: updateSibling,
    remove: removeSibling,
  } = useTreatmentPlanV3ClientSiblings();
  const {
    additionalInfo,
    hasSavedValues,
    isSaving: isSavingAdditionalInfo,
    create: createAdditionalInfo,
    remove: removeAdditionalInfo,
  } = useTreatmentPlanV3FamilyAdditionalInfo();
  const { culturalConsideration, save: saveCulturalConsideration } =
    useTreatmentPlanV3FamilyCulturalConsideration();
  const readOnly = useFormReadOnly();

  return (
    <TreatmentPlanV3PageContent title="Family background">
      <TreatmentPlanV3PageLoadState
        errorMessage="Unable to load family information. Please try again."
        hasLoaded={hasLoaded}
        hasLoadError={hasLoadError}
        onRetry={retry}
      >
        {isSavingMember ? <FProgressBar /> : null}
        <FamilyFields
          additionalInfo={additionalInfo}
          culturalConsideration={culturalConsideration}
          disabled={isLoading || readOnly}
          familyMembers={familyMembers}
          hasSavedValues={hasSavedValues}
          isSavingAdditionalInfo={isSavingAdditionalInfo}
          isSavingMember={isSavingMember}
          isSavingSibling={isSavingSibling}
          onCreateAdditionalInfo={createAdditionalInfo}
          onCreateMember={createMember}
          onCreateSibling={createSibling}
          onDeleteAdditionalInfo={removeAdditionalInfo}
          onDeleteMember={removeMember}
          onDeleteSibling={removeSibling}
          onSaveCulturalConsideration={saveCulturalConsideration}
          onUpdateMember={updateMember}
          onUpdateSibling={updateSibling}
          richTextCulturalConsideration
          showListErrors
          siblings={siblings}
        />
      </TreatmentPlanV3PageLoadState>
    </TreatmentPlanV3PageContent>
  );
}
